import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserKycApplicationFieldDto } from '../../../../_core/_model/compliance';

@Component({
  selector: 'app-compliance-fields-step',
  standalone: false,
  templateUrl: './compliance-fields-step.html'
})
export class ComplianceFieldsStep {
  @Input() form!: FormGroup;
  @Input() fields: UserKycApplicationFieldDto[] = [];

  isTextarea(field: UserKycApplicationFieldDto): boolean {
    const type = (field.fieldType || '').toLowerCase();
    return ['textarea', 'multilinetext', 'address'].includes(type);
  }

  inputType(field: UserKycApplicationFieldDto): string {
    const type = (field.fieldType || '').toLowerCase();

    if (type === 'email') return 'email';
    if (type === 'phone') return 'tel';
    if (type === 'date') return 'date';
    if (type === 'number') return 'number';

    return 'text';
  }

  trackByField = (_: number, item: UserKycApplicationFieldDto) => item.fieldKey;

  isSelect(field: UserKycApplicationFieldDto): boolean {
    return (field.fieldType || '').toLowerCase() === 'select';
  }

  getSelectOptions(field: any): any[] {
    if (Array.isArray(field.options)) {
      return field.options;
    }

    if (!field.optionsJson) {
      return [];
    }

    try {
      const parsed = JSON.parse(field.optionsJson);

      if (!Array.isArray(parsed)) {
        return [];
      }

      return parsed.map((item: any) => {

        if (typeof item === 'string') {
          return {
            label: item,
            value: item
          };
        }

        return {
          label: item?.label ?? '',
          value: item?.value ?? ''
        };
      });
    }
    catch {
      return [];
    }
  }

  getMinDate(field: any): string | null {

    const validation = field.validation;

    if (!validation?.minDate) {
      return null;
    }

    if (validation.minDate === 'today') {
      return this.today();
    }

    return validation.minDate;
  }

  getMaxDate(field: any): string | null {

    const validation = field.validation;

    if (!validation?.maxDate) {
      return null;
    }

    if (validation.maxDate === 'today') {
      return this.today();
    }

    return validation.maxDate;
  }

  private today(): string {
    return new Date().toISOString().split('T')[0];
  }
}